export default __webpack_public_path__ + "static/media/icon-youtube.d31ed2f6.svg";